import Link from "next/link"
import { Button } from "@/components/ui/button"

export default function NotFound() {
  return (
    <section className='rounded-2xl border bg-white p-6 shadow-xs md:p-8'>
      <div className='flex min-h-[400px] flex-col items-center justify-center gap-4 text-center'>
        <h2 className='font-semibold text-2xl'>Pedido não encontrado</h2>
        <p className='text-muted-foreground'>
          O pedido solicitado não foi encontrado ou você não tem permissão para
          visualizá-lo.
        </p>
        <Button asChild>
          <Link href='/minha-conta/pedidos'>Voltar para meus pedidos</Link>
        </Button>
      </div>
    </section>
  )
}
